export default {
  common: {
    back: '← Back',
    backHome: '← Back to Home',
    loading: 'Loading...',
    submitting: 'Submitting...',
    querying: 'Querying...',
    retry: 'Search Again',
  },
  home: {
    brand: 'Recharge Portal',
    brandSub: 'Account Upgrade Service',
    heroTitle: 'Recharge & Account Upgrade Service',
    heroSub: 'Verify your account and CDK, then confirm — step by step',
    flowTitle: 'How It Works',
    services: {
      recharge: { title: 'Recharge', en: 'Recharge Portal', cta: 'Start Recharge', p1: 'Verify CDK code', p2: 'Submit session', p3: 'Confirm submission' },
      batch: { title: 'Batch Redeem', en: 'Batch Redeem', cta: 'Start Batch', p1: 'Verify CDK list', p2: 'Import Excel sessions', p3: 'Match and submit in order' },
      lookup: { title: 'CDK Status', en: 'CDK Status', cta: 'Check CDK', p1: 'Paste one or many CDKs', p2: 'See if used', p3: 'Show recharge email' },
      billing: { title: 'Billing', en: 'Billing Tool', cta: 'Check Billing', p1: 'Paste session', p2: 'Query billing info', p3: 'View subscription' },
    },
    flows: {
      submit: { title: 'Submit Flow', s1: 'Verify CDK — match plan and status', s2: 'Submit session — paste the JSON from chatgpt.com/api/auth/session', s3: 'Confirm — agree to terms and submit' },
      batch: { title: 'Batch Redeem', s1: 'Verify CDKs — batch preview', s2: 'Import sessions — Excel/CSV auto-detect', s3: 'Match & submit — redeem in order and track progress' },
      lookup: { title: 'CDK Status', s1: 'Enter CDKs — one or a pasted list', s2: 'Check status — used or not', s3: 'See email — which account was recharged' },
      billing: { title: 'Billing Lookup', s1: 'Session input — paste your token', s2: 'Query billing — click to look up', s3: 'Result — shown after the query' },
    },
  },
  redeemTabs: {
    single: 'Redeem Now',
    batch: 'Batch Redeem',
    lookup: 'CDK Status',
    billing: 'Billing',
  },
  batch: {
    title: 'Batch Redeem',
    subtitle: 'Verify CDKs → pair Session or email/password → submit and watch progress',
    panelTitle: 'Batch Redeem',
    panelHint: 'Verify CDKs → choose Session or email/password → match and submit in order',
    cdkListLabel: 'CDK list (one per line, max {max})',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX\n…',
    cdkRecognized: '{n} CDKs detected',
    cdkQueueHint: 'Large batches run with limited concurrency — ensure upstream capacity',
    credMode: 'Credential mode',
    modeSession: 'Session',
    modeMailbox: 'Email + password',
    mailboxLabel: 'Email/password list (one per line)',
    mailboxPlaceholder: 'email----password\nemail:password\nemail,password',
    mailboxLinePlaceholder: 'email----password or email:password',
    mailboxRecognized: '{n} mailboxes detected',
    mailboxImportBtn: 'Import Excel / CSV / TXT (email + password)',
    mailboxHint: 'Supports mail.tm / Outlook. Format: email----password; Excel needs email + password columns',
    mailboxPairHint: 'Pairing: 1st valid CDK ↔ 1st mailbox, and so on. Live progress shows account and card last4.',
    excelLabel: 'Session Excel (optional)',
    clearImport: 'Clear import',
    importing: 'Parsing…',
    imported: '{n} imported · click to replace',
    importBtn: 'Import Excel / CSV (auto-detect session column)',
    excelHint: 'Supports xlsx / csv. gptbuy format “email,email password,GPT password,token,session” uses the session column. Redeem needs full Session JSON (with sessionToken) or 5-part JWE — not bare Access Token',
    verifying: 'Verifying…',
    verifyStart: 'Verify batch and start',
    verifyingKeys: 'Verifying CDKs…',
    statTotal: 'Total',
    statWait: 'Awaiting credential',
    statRun: 'Running',
    statOkFail: 'OK / Fail',
    currentOrdinal: '{n} / {total}',
    remaining: '{n} left',
    willUseAccount: 'Using account:',
    sessionPlaceholder: 'Paste full Session JSON (must include sessionToken) or 5-part JWE; auto-filled after import',
    submitting: 'Submitting…',
    submitNext: 'Submit and continue',
    autoSubmitting: 'Auto-submitting…',
    autoSubmit: 'Auto-submit all (CDK×credential by order, {n} in pool)',
    pairHint: 'Pairing: 1st valid CDK ↔ 1st Excel session, and so on. Progress updates below after submit.',
    allSubmitted: 'All credentials submitted ({n})',
    watchProgress: 'Keep watching progress below',
    exportOk: 'Export successful accounts ({n})',
    noValidKeys: 'No valid CDKs to redeem',
    liveProgress: 'Live progress',
    account: 'Account',
    card: 'Card',
    cardPending: 'Last4 after card open',
    reset: 'Back · start over',
    status: {
      pending_verify: 'Pending',
      verify_ok: 'Valid',
      verify_fail: 'Invalid',
      waiting_session: 'Need credential',
      submitting: 'Submitting',
      processing: 'Processing',
      success: 'Success',
      failed: 'Failed',
    },
  },
  recharge: {
    title: 'Recharge',
    subtitle: 'Recharge Portal · Account recharge request',
    steps: { s1: 'Verify CDK', s2: 'Submit Session', s3: 'Confirm' },
    step1Title: 'Verify CDK Code',
    cdkLabel: 'CDK Code',
    cdkValid: '✓ CDK valid',
    planType: 'Plan Type',
    cdkTypesHint: 'Supported CDK types: pro, 5x, 20x.',
    verifying: 'Verifying...',
    next: 'Next →',
    prev: '← Previous',
    step2Title: 'Submit Session',
    howToGetSession: 'How to get your Session?',
    sessionGuidePrefix: 'After logging into ChatGPT, open in your browser',
    sessionGuideSuffix: ', copy the full JSON returned, and paste it into the box below.',
    sessionLabel: 'Session JSON',
    sessionHint: 'Paste the full session JSON from chatgpt.com/api/auth/session',
    sessionWarn: '⚠ Please paste the complete session JSON; it will be validated before submission',
    step3Title: 'Confirm & Submit',
    sessionStatus: 'Session Status',
    sessionFilled: '✓ Provided',
    agreePrefix: 'I have read and agree to the',
    terms: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy',
    submitSuccessTitle: '✓ Request submitted successfully!',
    taskId: 'Task ID',
    submitSuccessHint: 'Submitted. Use CDK Status to see whether the code is used and which email was recharged.',
    confirmSubmit: 'Confirm & Submit',
    errInvalidCdk: 'Invalid CDK',
    errVerifyFailed: 'Verification failed',
    errCreateFailed: 'Failed to create task',
    errConfirmFailed: 'Confirmation failed',
    errNetwork: 'Network error',
  },
  cdkLookup: {
    title: 'CDK Status',
    subtitle: 'Check whether a CDK is used and which email was recharged (no token)',
    queryTitle: 'Enter CDK',
    queryHint: 'Enter the full CDK. Only use-status and recharge email are returned — never session/token.',
    modeSingle: 'Single',
    modeBatch: 'Batch',
    batchHint: 'One per line, or separated by spaces/commas. Max {max} per query. Never returns session/token.',
    batchLabel: 'CDK list',
    batchPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX\nSXC-YYYY-YYYY-YYYY-YYYY',
    batchRecognized: '{n} CDKs detected',
    batchTruncated: 'Over the limit — only the first {max} will be queried',
    batchQueryBtn: 'Check all',
    batchEmpty: 'Paste at least one CDK first',
    copyEmails: 'Copy used emails',
    exportCsv: 'Export CSV',
    copied: 'Copied',
    copyFail: 'Copy failed',
    summaryUsed: 'Succeeded {n}',
    summaryFailed: 'Failed {n}',
    summaryUnused: 'Unused {n}',
    summaryProcessing: 'Processing {n}',
    summaryUnknown: 'Not found {n}',
    cdkLabel: 'CDK Code',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX',
    queryBtn: 'Check CDK Status',
    resultTitle: 'Result',
    cdkCode: 'CDK',
    useStatus: 'Result',
    rechargeEmail: 'Recharge email',
    emailEmpty: '—',
    plan: 'Plan',
    usedAt: 'Used at',
    queryOther: 'Check another CDK',
    resubmit: 'Resubmit',
    goRedeem: 'Redeem',
    msgUsed: 'This CDK was used successfully.',
    msgFailed: 'This CDK failed.',
    msgUnused: 'This CDK has not been used yet.',
    msgProcessing: 'This CDK redeem is in progress.',
    errNotFound: 'CDK not found',
    errNetwork: 'Network error, please retry',
    status: {
      unused: 'Unused',
      used: 'Succeeded',
      failed: 'Failed',
      disabled: 'Disabled',
      expired: 'Expired',
      processing: 'Processing',
      unknown: 'Unknown',
    },
  },

  dashboard: {
    title: 'Billing Tool',
    subtitle: 'Billing Tool · Query account subscription and billing',
    step1Title: 'Paste Session to Query',
    hint: 'Paste the session JSON or access token you want to check.',
    inputLabel: 'Session JSON or access token',
    inputPlaceholder: 'Paste session JSON or access token',
    inputExample: 'e.g. {"access_token":"sk-xxx"} or paste the token directly',
    queryBtn: 'Query Billing',
    resultTitle: 'Billing Result',
    accountInfo: 'Account Info',
    email: 'Email',
    subStatus: 'Subscription',
    currentPlan: 'Current Plan',
    billingInfo: 'Billing Info',
    billingAmount: 'Amount',
    currency: 'Currency',
    nextBilling: 'Next Billing Date',
    queryOther: 'Query Another Account',
    notFoundTitle: 'No billing found for this session',
    notFoundHint: 'Please check whether the session is correct',
    msgActive: '✓ Subscription active, account is in good standing',
    msgInactive: '⚠ Subscription inactive, please check billing info',
    msgExpired: '✗ Subscription expired, please update payment info',
    errQueryFailed: 'Query failed',
    errNetwork: 'Network error, please try again',
    status: { active: 'Active', inactive: 'Inactive', expired: 'Expired' },
  },
  login: {
    title: 'Admin Login',
    subtitle: 'Log in to the admin console for CDK issue, redeem recon and site settings.',
    username: 'Username',
    usernamePlaceholder: 'Enter username',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    errLoginFailed: 'Login failed',
    errNetwork: 'Network error, please try again later',
  },
  notFound: {
    title: 'Page Not Found',
    home: 'Back to Home',
  },
}
